import type {
    BacklogListImport,
    BatchSelectedAddressRow,
    LoadListOutput,
    LoadListSource,
} from "../../../_shared/_logic/batch-upload-contract"
import { formatAddress } from "../_shared/_logic/address-import"
export type BuildLoadListOutputInput = {
    propertyPool: Property[]
    selectedPropertyIds: string[]
    selectedUnitIdsByPropertyId: Record<string, string[]>
    importedFromList: boolean
    selectionSourcesByPropertyId?: Record<string, LoadListSource[]>
    backlogListImport?: BacklogListImport | null
    unitContactContexts?: LoadListOutput["unitContactContexts"]
    selectedTargets: Array<{
        rowId: string
        propertyId: string
        propertyUnitId: string
        orderFields: import("../../../_shared/_logic/work-order-creation").WorkOrderCreationFields
        planningOrigin?: import("../../../_shared/_logic/batch-upload-contract").BatchSelectedAddressRow["planningOrigin"]
    }>
}

export const buildLoadListOutput = (input: BuildLoadListOutputInput): LoadListOutput => {
    const propertiesById = new Map(input.propertyPool.map((property) => [property.id, property]))

    return {
        propertyPool: input.propertyPool,
        selectedUnitIdsByPropertyId: input.selectedUnitIdsByPropertyId,
        importedFromList: input.importedFromList,
        selectionSourcesByPropertyId: input.selectionSourcesByPropertyId,
        backlogListImport: input.backlogListImport,
        unitContactContexts: input.unitContactContexts ?? [],
        selectedRows: input.selectedTargets.flatMap(
            ({ rowId, propertyId, propertyUnitId, orderFields, planningOrigin }) => {
                const property = propertiesById.get(propertyId)

                return property
                    ? [
                          {
                              rowId,
                              orderFields,
                              planningOrigin,
                              propertyId,
                              propertyUnitId,
                              property,
                              addressLabel: formatAddress(property, propertyUnitId),
                          },
                      ]
                    : []
            }
        ),
    }
}
